import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c7e8afc6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e8afc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e8afc6')) {
      api.createRecord('c7e8afc6', component.options)
    } else {
      api.reload('c7e8afc6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c7e8afc6&scoped=true", function () {
      api.rerender('c7e8afc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/rightBtn/index.vue"
export default component.exports